// "Book a demo" targets. No backend — these are plain WhatsApp / email links.
export const WHATSAPP_NUMBER = '9609925635'; // +960 992 5635
export const DEMO_EMAIL = 'mohamedirufaam@gmail.com';

const DEMO_MESSAGE = "Hi — I'd like a demo of Wapplify Office for my council.";

export const bookDemoUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(DEMO_MESSAGE)}`;

export const demoMailto =
  `mailto:${DEMO_EMAIL}` +
  `?subject=${encodeURIComponent('Wapplify Office — demo request')}` +
  `&body=${encodeURIComponent(DEMO_MESSAGE)}`;
